import {styled} from 'styled-components';
import {typographyTitleBodyStyles} from '../../modules/common/styles/typography';

export const StyledTextAdornment = styled.span`
    ${typographyTitleBodyStyles}
    padding: ${({theme}) => `calc(${theme.spacing.s} - 2px )`};
    padding-right: 0;
    align-self: center;
`;
